export const containerStyles = 'p-6 rounded-2xl border flex items-center gap-2'
export const contentStyles = 'flex flex-col gap-1 flex-1'
export const titleStyles = 'text-md-semibold'
export const descriptionStyles = 'text-sm-regular'
